"use client";

import Link from "next/link";
import { useEffect, useMemo, useState } from "react";
import useGetSearchParams from "@/lib/hooks/useGetSearchParams";
import useGetFilterProduct from "@/lib/hooks/useGetFilterProduct";

import { FilterProduct } from "@/types/Product.type";

import Button from "@/components/ui/Button";
import RangeSliderCustom from "../RangeSlider";
import { CloseTagIcon } from "@/components/icons";
import ChevronRightIcon from "@/components/icons/ChevronRightIcon";
import ProductFilterBrandMobile from "./ProductFilterBrandMobile";

export type SidebarItemJson = {
  label: string;
  value: string;
};

interface Tag {
  value: string | [number, number];
  label: string;
  type: keyof FilterProduct;
}

type FilterProductTypeMobie = Pick<
  FilterProduct,
  "brand" | "price_max" | "price_min"
> & {
  [key: string]: any;
};

const ProductFilterSortType = ({
  collectionHandle,
  onFilter,
}: {
  onFilter: (filter: FilterProduct) => void;
  collectionHandle?: string;
}) => {
  const params: any = useGetSearchParams();
  const { isLoadingBrand, setDefaultBrandFilter, valueFilters } =
    useGetFilterProduct({ collectionHandle: collectionHandle || "" });
  //states
  const [tagsFilter, setTagsFilter] = useState<Tag[]>([]);

  const [openFilterChilds, setOpenFilterChilds] = useState({
    brand: false,
    size: false,
  });
  //   console.log(isLoadingBrand);
  const [filterState, setFilterState] = useState<FilterProduct>(
    {} as FilterProduct
  );

  useEffect(() => {
    // set filter mặc định và ép các kiểu number theo params
    const defaultFilter: FilterProduct = {
      ...params,
      rating: Number(params.rating) || undefined,
      price_max: Number(params.price_max) || undefined,
      price_min: Number(params.price_min) || undefined,
    };
    setFilterState(defaultFilter);
  }, [JSON.stringify(params)]);

  function hanlderPushParams() {
    let query: FilterProduct = {
      ...filterState,
      page: 1,
    };
    onFilter(query);
  }

  function handleRemoveTag(item: Tag) {
    switch (item.type) {
      case "brand":
        setFilterState((pre) => {
          return {
            ...pre,
            brand:
              pre.brand
                ?.split(",")
                .filter((bra) => bra !== item.value)
                .join(",") || undefined,
          };
        });
        break;
      default:
        break;
    }
  }

  const filterItems: {
    name: keyof FilterProductTypeMobie;
    children: JSX.Element;
  }[] = useMemo(() => {
    return [
      {
        name: "brand",
        children: (
          <>
            <li
              className="flex items-center justify-between"
              onClick={() => {
                setOpenFilterChilds((pre) => {
                  return {
                    ...pre,
                    brand: true,
                  };
                });
              }}
            >
              <span>Thương hiệu</span>
              <span>
                <ChevronRightIcon className="min-w-[24px]" />
              </span>
            </li>
            <ProductFilterBrandMobile
              drawerProps={{
                open: openFilterChilds.brand,
                onClose: () => {
                  setOpenFilterChilds((pre) => ({ ...pre, brand: false }));
                },
              }}
              brands={
                valueFilters.brandsSearch.items.length
                  ? valueFilters.brandsSearch
                  : valueFilters.brands
              }
              defaultValues={filterState.brand}
              onSubmit={(data) => {
                setFilterState((pre) => ({
                  ...pre,
                  brand: data.length ? data.join(",") : undefined,
                }));
              }}
              onSearch={(keyword) => {
                setDefaultBrandFilter((pre) => ({ ...pre, keyword: keyword }));
              }}
              onLoadMore={() =>
                setDefaultBrandFilter((pre) => ({
                  ...pre,
                  page: Number.parseInt(pre.page?.toString() || "1") + 1,
                }))
              }
              isLoading={isLoadingBrand}
            />
          </>
        ),
      },
      // {
      //   name: "size",

      //   children: <>
      //     <li
      //       className="h-[40px] flex items-center justify-between"
      //       onClick={() => {

      //         setOpenFilterChilds(pre => {
      //           return {
      //             ...pre,
      //             brand: true
      //           }
      //         })
      //       }}
      //     >
      //       <span >Thương hiệu</span>
      //       <span>
      //         <ChevronRightIcon className="min-w-[24px]" />
      //       </span>
      //     </li>
      //     <ProductFilterBrandMobile drawerProps={{
      //       open: openFilterChilds.brand,
      //       onClose: () => { setOpenFilterChilds(pre => ({ ...pre, brand: false })) }
      //     }}
      //       brands={valueFilters.brandsSearch.items.length ?  valueFilters.brandsSearch : valueFilters.brands}
      //       defaultValues={filterState.brand}
      //       onSubmit={(data) => {
      //         setFilterState(pre => ({ ...pre, brand: data.length ? data.join(",") : undefined }))
      //       }}
      //       onSearch={(keyword) => {
      //         setDefaultBrandFilter(pre => ({ ...pre, keyword: keyword }))
      //       }}
      //       onLoadMore={() => setDefaultBrandFilter(pre => ({ ...pre, page: Number.parseInt(pre.page.toString()) + 1 }))}

      //     />
      //   </>
      // },
      {
        name: "price_max",
        children: (
          <li>
            <p className="leading-[40px]">Theo giá</p>
            <RangeSliderCustom
              initialMin={valueFilters.priceMin}
              initialMax={valueFilters.priceMax}
              min={filterState.price_min || valueFilters.priceMin}
              max={filterState.price_max || valueFilters.priceMax}
              step={50000}
              onChange={({ priceMax, priceMin }) => {
                setFilterState((pre) => ({
                  ...pre,
                  price_max: priceMax,
                  price_min: priceMin,
                }));
              }}
            />
          </li>
        ),
      },
    ];
  }, [
    JSON.stringify(valueFilters),
    JSON.stringify(filterState),
    JSON.stringify(openFilterChilds),
    isLoadingBrand,
  ]);

  useEffect(() => {
    const keyUse = filterItems.map((item) => item.name);
    let keyUseValid: string[] = [];
    // Kiểm tra xem mảng keyUse chỉ chứa các chuỗi
    for (const key of keyUse) {
      // Làm gì đó với key
      if (typeof key === "string") {
        keyUseValid.push(key);
      }
    }
    const tags = convertFilterParamsToTags(
      {
        brand: filterState.brand,
        price_max: filterState.price_max,
        price_min: filterState.price_min,
      },
      keyUseValid
    );

    setTagsFilter(tags);
  }, [JSON.stringify(filterState)]);

  return (
    <>
      <ul className="h-fit px-4 py-2 flex gap-1 text-sm flex-wrap">
        {tagsFilter.map((item, index) => {
          return (
            <li
              className="bg-gray-300 border-shop-gray3 rounded-[4px] h-[32px] w-fit p-2 flex items-center"
              key={index}
              onClick={() => {
                handleRemoveTag(item);
              }}
            >
              {item.label}
              <span>
                <CloseTagIcon />
              </span>
            </li>
          );
        })}
      </ul>
      <div className="bg-gray-200 text-gray-500 font-bold px-4 py-3">
        Lọc theo
      </div>
      <div className="p-4 flex flex-col gap-4">
        <ul className="flex flex-col gap-4">
          {filterItems.map((item) => {
            return <div key={item.name}>{item.children}</div>;
          })}
        </ul>
        <Button
          mode="main"
          label="Hiện kết quả"
          className="w-full text-sm h-[34px] rounded-[4px] z-[101]"
          onClick={(e) => {
            e && e.preventDefault();
            hanlderPushParams();
          }}
        />
      </div>
    </>
  );
};

export default ProductFilterSortType;

function convertFilterParamsToTags(
  filter: FilterProductTypeMobie,
  tagUse: string[]
): Tag[] {
  const tags: Tag[] = [];

  // Lọc ra các thuộc tính cần thiết từ filterState
  const filteredFilterState = Object.keys(filter)
    .filter((key) => tagUse.includes(key) && filter[key] !== undefined)
    .reduce((obj, key) => {
      obj[key] = filter[key];
      return obj;
    }, {} as FilterProductTypeMobie);

  // Ánh xạ từng trường hợp sang tags
  const tagMappings: {
    [key: keyof FilterProductTypeMobie]: (data: any) => Tag[];
  } = {
    brand: (data: string) => {
      const list = data.split(",");
      return list.map((item) => ({ value: item, label: item, type: "brand" }));
    },

    // Thêm các trường hợp khác ở đây nếu cần
  };

  // Tạo tags từ các trường hợp đã ánh xạ
  Object.keys(filteredFilterState).forEach((key) => {
    if (tagMappings[key]) {
      tags.push(...tagMappings[key](filteredFilterState[key]));
    }
  });

  return tags;
}
